const adresses = (centers) => {
  const form = document.querySelector(".form form");

  if (!form) return;
  
  const selectAdresses = form.querySelector("#ExaminationAreaId");
  const selectExamType = form.querySelector("#ExamType");
  const checkbox = form.querySelector(".form__checkbox");
  const linkPolicy = form.querySelector(".form__checkbox a");
  const inputCheckbox = checkbox.querySelector(".form__checkbox input");
  const btnSubmit = form.querySelector('button[type="submit"]');
  let allAreas = centers;

  let targetTypeExam = '';
  let targetExaminationArea = '';

  /* Базовое добавление адресов не привязанных к типу экзамена */
  addOptionsAdress('');

  /* В блоке "Виды экзамена" при нажатии на конпку "Оставить заявку" или "Записаться" в форме предустанавливается выбранный вариант */
  (() => {
    const exams = document.querySelectorAll("[data-exams]");
    const select = $('#ExamType');

    exams.forEach(btn => {
      btn.addEventListener('click', () => {
        if (targetExaminationArea == '') {
          let value = btn.getAttribute('data-exams');
          select.val(value).trigger('change');
        }
      })
    })     
  })();

  /* В блоке "Центры тестирования" при нажатии на конпку "Записаться" в форме предустанавливается выбранный вариант */
  (() => {
    const select = $('#ExaminationAreaId');

    document.addEventListener('click', (e) => {
      if (targetTypeExam == '') {
        let target = e.target;
        
        if (target.getAttribute('data-area')) {
          let value = target.getAttribute('data-area');
          select.val(value).trigger('change');
        }
      }
    })
  })();

  /* Вывод сообщения на селекте */
  inputCheckbox.parentNode.addEventListener("click", () => {
    if (checkbox.classList.contains("disabled")) {
      createMessage(inputCheckbox, "Выберите экзаменационную площадку");
    }
  });

  /* Вывод сообщения на селекте */
  selectAdresses.parentNode.addEventListener("click", () => {
    if (selectAdresses.disabled) {
      createMessage(selectAdresses, "Выберите тип экзамена");
    }
  });

  /* Логика при изменении поля вида экзамена */
  selectExamType.onchange = (e) => {
    if (targetExaminationArea == '') {      
      targetTypeExam = e.target.value;
      addOptionsAdress(targetTypeExam);
      addMessageError(selectAdresses);
      disabledCheckbox("disabled");
    }

    removeMessageError(selectExamType);
    activationButtonSubmit();
  };

  /* Логика при изменении поля адреса */
  selectAdresses.onchange = (e) => {
    if (targetTypeExam == '') {  
      targetExaminationArea = e.target.value;
      addOptionsTypesExam(targetExaminationArea);
      addMessageError(selectExamType);
    }
    
    [...selectAdresses].forEach((area) => {
      if (e.target.value == area.value) {
        let link = area.getAttribute("link");
        
        if (link == 'null' || !link) {
          linkPolicy.href = "/files/PD_Policy.pdf";            
        } else {
          linkPolicy.href = link;            
        }
      }
    });

    disabledCheckbox("enable");
    removeMessageError(selectAdresses);      
    activationButtonSubmit();
  };

  /* Добавление типов экзаменов */
  function addOptionsTypesExam(id) {
    let allAreasDublicate = structuredClone(allAreas);

    allAreasDublicate.forEach((area) => {
      if (area.migrationExamTypes.length > 0) {
        if (area.examinationAreaId == id) {
          [...selectExamType.children].map((item) => {
            item.remove();
          });
      
          area.migrationExamTypes.forEach((type) => {
            let option = new Option(
              type.examName,
              type.examTypeId,
              false,
              false
            );
      
            selectExamType.append(option);
          });
        }
      }
    })    

    $(`#ExamType`).val(null).trigger("change");
  }

  /* Добавление адресов */
  function addOptionsAdress(examType) {
    let allAreasDublicate = structuredClone(allAreas);
    let listAreasEnable = [];
    let listAreasDisable = [];
    
    allAreasDublicate.forEach((area) => {
      let isNotDisabled, areaName;

      if (area.isRemoteSubmissionAvailable == false) {
        isNotDisabled = false;
        areaName = `<span class="examinationAreaAddress">${area.examinationAreaAddress}</span> <br><span class="examinationAreaFullName">${area.examinationAreaFullName}</span><br><span class="areaInfo disabled">Недоступно для выбора</span>`;
      } else {
        let status = false;

        area.migrationExamTypes.forEach((type) => {
          if (type.examTypeId == examType || examType == '') {
            status = true;
          }
        });

        if (status) {
          isNotDisabled = true;
          areaName = `<span class="examinationAreaAddress">${area.examinationAreaAddress}</span> <br><span class="examinationAreaFullName">${area.examinationAreaFullName}</span><br><span class="areaInfo active">Доступно для выбора</span>`;
        } else {
          isNotDisabled = false;
          areaName = `<span class="examinationAreaAddress">${area.examinationAreaAddress}</span> <br><span class="examinationAreaFullName">${area.examinationAreaFullName}</span><br><span class="areaInfo disabled">Недоступно для выбора</span>`;
        }
      }

      let AREA = {};
      AREA.text = areaName;
      AREA.status = isNotDisabled;
      AREA.id = area.examinationAreaId;
      AREA.link = area.linkToProcessingPersonalData;
      
      if (isNotDisabled) {
        listAreasEnable.push(AREA);
      } else {
        listAreasDisable.push(AREA);
      }
    });

    listAreasEnable.sort((a, b) => (a.text > b.text ? 1 : -1));
    listAreasDisable.sort((a, b) => (a.text > b.text ? 1 : -1));

    [...selectAdresses.children].map((item) => {
      item.remove();
    });

    listAreasEnable.forEach((area) => {
      let option = new Option(
        '<span class="examinationAreaAddress">г.</span> ' + area.text,
        area.id,
        false,
        false
      );

      option.setAttribute("link", area.link);
      selectAdresses.append(option);
    });

    listAreasDisable.forEach((area) => {
      let option = new Option(
        '<span class="examinationAreaAddress">г.</span> ' + area.text,
        area.id,
        false,
        false
      );

      option.setAttribute("disabled", "disabled");
      selectAdresses.append(option);
    });

    $(`#ExaminationAreaId`).val(null).trigger("change");
  }

  /* Удаление сообщения об обязательном заполнении поля */
  function removeMessageError(element) {
    let parent = element.parentNode;
    const parentMessage = parent.querySelector(".input-message");

    parent.classList.remove("is-invalid");
    parent.classList.add("is-valid");
    if (parentMessage) {
      parentMessage.remove();
    }
  }

  /* Добавление сообщения об обязательном заполнении поля на селект Адресов */
  function addMessageError(element) {
    let parentAdresses = element.parentNode;
    const parentMessageAdresses = parentAdresses.querySelector(".input-message");

    parentAdresses.classList.add("is-invalid");
    parentAdresses.classList.remove("is-valid");
    if (!parentMessageAdresses) {
      let span = document.createElement('span');
      span.classList.add('input-message', 'is-invalid');
      span.textContent = 'Поле обязательно к заполнению';
      parentAdresses.appendChild(span);
    }
  }

  /* Блокировка / разблокировка чекбокса */
  function disabledCheckbox(status) {
    if (status == "disabled") {
      checkbox.classList.add("disabled");
      checkbox.classList.remove("is-valid");
      inputCheckbox.checked = false;
      linkPolicy.href = "";
    } else {
      checkbox.classList.remove("disabled");
      inputCheckbox.checked = false;
    }
  }

  /* Вывод сообщения */
  function createMessage(field, text) {
    const message = field.parentNode.querySelector("[data-form-mesage]");

    if (message) return;

    let div = document.createElement("div");
    div.setAttribute("data-form-mesage", "");
    div.classList.add("form__message");
    div.innerHTML = `
        <div class="form__message-wrapper">
          <p>${text}</p>
        </div>
      `;
    field.parentNode.appendChild(div);

    setTimeout(() => {
      div.remove();
    }, 5000);
  }

  /* Активация кнопки отправки при заполненных полях */
  function activationButtonSubmit() {
    const fields = form.querySelectorAll("input, select, textarea");
    let status = true;

    fields.forEach(field => {
      if (!field.parentElement.classList.contains('is-valid')) {
        status = false;
      }
    })
    
    if (status == true && inputCheckbox.checked == true) {
      btnSubmit.disabled = false;
    } else {
      btnSubmit.disabled = true;
    }    
  }
};

export default adresses;
